import React, { ComponentType, VoidFunctionComponent } from 'react';
import { WixPatternsBMProvider } from './CairoBMProvider';

type ExtractProps<C> = C extends ComponentType<infer P> ? P : never;

/**
 * @deprecated
 * use `withWixPatternsProvider`
 */
export function withCairoProvider<C extends VoidFunctionComponent<any>>(
  WrappedComponent: C,
): C {
  return ((props: ExtractProps<C>) => (
    <WixPatternsBMProvider>
      <WrappedComponent {...props} />
    </WixPatternsBMProvider>
  )) as C;
}

export const withWixPatternsProvider = withCairoProvider;
